import React from "react";
import css from "./TypeText.module.css";
import {capitalize} from "vritra";


export default function TypeText(props){
    const {type}=props;
    return (
        <span 
            {...props}
            type={undefined}
            className={`${css.typetext} ${props.className||""}`} 
            {...typeof(type)==="object"&&{
                onClick:()=>{
                    const {hash}=type;
                    if(hash){
                        location.hash=hash;
                    }
                    else if(type.url){
                        window.open(type.url,"_blank","popup=false");
                    }
                    else if(type.name){
                        const libname=location.hash.split(/#/g).filter(Boolean)[0];
                        location.replace(`#${libname}#${type.name}`);
                    }
                },
                hashref:"",
            }}
        >
            {(()=>{
                let text=typeof(type)==="string"?type:type.name;
                text=text.split(":").map(str=>capitalize(str,1)).join(":");
                ["|","?",":","(",")","=>",",","&"].forEach(pattern=>{
                    text=text.replaceAll(pattern,` ${pattern} `);
                });
                return capitalize(text,1);
            })()}
        </span> 
    )
}
